
var spanplusApp = angular.module('spanplusApp', ['ngRoute', 'ngAnimate', 'ngMaterial', 'ngSanitize', 'ngResource', 'angular-growl',
    'infinite-scroll', 'search', 'web', 'common', 'quote', 'dealership', 'users','remitRegister','taillightUx']);

spanplusApp.constant('routes', {
    createQuote: '/create-quote',
    dealerSettings: '/dealer-settings',
    dealershipSearch: '/dealership-search',
    login: '/login',
    quoteIntegration: '/quote-integration',
    remitRegister: '/remit-register',
    search: '/search',
    userManage: '/user-manage',
    welcome: '/welcome',
    logout: '/logout',
    error: '/error-page',
    ssoIntegration: '/sso-redirect',
    showcaseLiteRedirect: '/showcaselite-intro'
});

// this is for secured/authorized areas that are not routes (such as dialogs and page sections)
spanplusApp.constant('additionalSecuritySections', {
    additionalMarkup : "ADDITIONAL_MARKUP",
    overRemit: 'OVER_REMIT',
    internetQuoting: 'INTERNET_QUOTING'
});

spanplusApp.constant('authRoles', {
    fiManager: 'SPAN F&I MANAGER',
    fiManagerRateOnly: 'SPAN F&I MANAGER - RATING ONLY',
    dealerOfficeManager: 'SPAN DEALER OFFICE MANAGER',
    providerCorp: 'SPAN PROVIDER CORP',
    providerFieldRep: 'SPAN PROVIDER FIELD REP',
    providerRepManager: 'SPAN PROVIDER REP MANAGER',
    admin: 'SPAN ADMIN',
    providerCorpAdmin: 'SPAN PROVIDER CORP ADMIN'
});

//This configures the routes and associates each route with a view and a controller
spanplusApp.config(['$routeProvider', '$locationProvider', '$httpProvider', 'routes',
    function ($routeProvider, $locationProvider, $httpProvider, routes) {

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    //disable IE ajax request caching
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    $routeProvider
        .when(routes.search,
        {
            controller: 'SearchController',
            templateUrl:  'app/modules/search/views/search.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.remitRegister,
        {
            controller: 'remitRegisterController',
            templateUrl: 'app/modules/remittance/views/remit-register.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.login,
        {
            controller: 'LoginController',
            templateUrl: 'app/modules/web/views/login.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.logout, {redirectTo: function(){
            sessionStorage.clear();
            return routes.login;
        }})
        .when(routes.welcome,
        {
            controller: 'welcomeController',
            templateUrl:  'app/modules/web/views/welcome.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.error,
            {
                controller: 'errorController',
                templateUrl:  'app/modules/web/views/error-page.html',
                access: {
                    requiresAuthenticatedUser: false
                }
            })
        .when(routes.createQuote,
        {
            controller: 'createQuoteController',
            templateUrl: 'app/modules/quote/views/create-quote-container.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.quoteIntegration,
        {
            controller: 'quoteIntegrationController',
            templateUrl: 'app/modules/quote/views/quote-integration.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.dealershipSearch,
        {
            controller: 'DealershipSearchController',
            templateUrl: 'app/modules/dealership/views/dealership-search.html',
            access: {
                requiresAuthenticatedUser: false
            }

        })
        .when(routes.dealerSettings,
        {
            controller: 'DealerSettingsController',
            templateUrl: 'app/modules/dealership/views/dealer-settings.html',
            access: {
                requiresAuthenticatedUser: false
            }

        })
        .when(routes.userManage,
        {
            controller: 'UsersController',
            templateUrl: 'app/modules/users/views/users.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.ssoIntegration,
        {
            controller: 'ssoIntegrationController',
            templateUrl: 'app/modules/web/views/sso-integration.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .when(routes.showcaseLiteRedirect,
        {
            controller: 'showcaseLiteIntroController',
            templateUrl: 'app/modules/web/views/showcase-intro.html',
            access: {
                requiresAuthenticatedUser: false
            }
        })
        .otherwise({ redirectTo: routes.login });
    // End $routProvider routing rules

    $locationProvider.html5Mode(true);

}]);

/*
    This section is responsible for loading the config file over http and bootstrapping the
    application once it is loaded.
 */
angular.element(document).ready(function () {
    if(!appModuleName) {
        console.error("'appModuleName' must be specified in the index template");
    } else {

        $.get('/config/default.json')
            .done(function (configData) {
                $.get('/config/override.json')
                    .done(function (overrideData) {
                        configData = angular.merge(configData, overrideData);
                    })
                    /*.fail(function () {
                        console.error("No override.json file found.");
                    })*/
                    .always(function() {
                        angular.module(appModuleName).config(['AppSettingsProvider', function (AppSettingsProvider) {
                            AppSettingsProvider.config(configData);
                        }]);
                        angular.bootstrap('#html', [appModuleName]);
                    });
            })
            .fail(function() {
                console.error("No config file found.");
            });
    }
});
